<script setup lang="ts">
type SurveyData = App.Surveys.Data.SurveyData;
import Button from '@/components/button/Button.vue';

import ClipboardNotes from '@/icons/line/clipboard-notes.svg';

defineProps<{
  survey: SurveyData;
}>();
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/domains/surveys/layouts/TwoColumns.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
  <div class="flex flex-col items-center gap-y-4 pt-8 text-center">
    <div class="flex size-13 items-center justify-center rounded-full bg-slate-700">
      <ClipboardNotes class="size-9 fill-white" />
    </div>
    <h2 class="text-2xl font-bold leading-7 text-slate-800">Begin Survey</h2>
    <p class="text-sm leading-5 text-slate-500">
      You are about to begin the <span class="font-bold">{{ survey.display_name }}</span> survey.
    </p>
    <Button :href="route('survey.redirect', { survey: survey.id })">Begin survey</Button>
  </div>
</template>
